import styled from "styled-components";

import { ComparisonSide } from "src/organization/pages/project/environment/observabilitySandbox/experiments/Conprof/types";

const cellHeight = 24;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 10px;
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 8px;
`;
export const HeaderBullet = styled.div<{ side: ComparisonSide }>`
  padding: 2px 8px;
  border-radius: 4px;

  background-color: ${({ side }) =>
    side === "A"
      ? "var(--mode-bg-primary-weakest)"
      : "var(--mode-bg-secondary-weakest)"};
  color: ${({ side }) =>
    side === "A"
      ? "var(--mode-text-primary-default)"
      : "var(--mode-text-secondary-default)"};
  }
`;
export const HeaderLegend = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  color: var(--mode-text-neutral-weakest);
`;
export const HeaderLegendTooltip = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: 100%;
  overflow: hidden;

  > div {
    display: flex;
    gap: 10px;
  }
`;
export const HeaderLegendTooltipSection = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;

  * {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`;
export const HeaderLegendTooltipSectionBullet = styled.div`
  width: 16px;
  height: 16px;
  border-radius: 4px;

  &.less {
    background-color: var(--color-java-500);
  }
  &.more {
    background-color: var(--color-red-500);
  }
`;

export const HeaderLegendScale = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  height: 20px;
`;
export const HeaderLegendScaleText = styled.div`
  width: auto;
`;
export const HeaderLegendScaleColors = styled.div`
  display: flex;
  gap: 2px;
  color: var(--theme-neutral-0);

  &.less > div {
    background-color: var(--color-java-500);
  }
  &.more > div {
    background-color: var(--color-red-500);
  }
`;
export const HeaderLegendScaleColor = styled.div`
  &.first {
    opacity: 0.6;
    width: 2px;
  }
  &.second {
    opacity: 0.2;
    width: 2px;
  }
`;
export const HeaderLegendScaleColorMain = styled(HeaderLegendScaleColor)`
  width: auto;
  min-width: 29px;
  color: #fff;
  display: flex;
  align-items: center;
  padding: 0 4px;
`;

export const HeaderLegendOnly = styled.div<{ side: ComparisonSide }>`
  width: 16px;
  height: 16px;
  border-radius: 4px;

  background-color: ${({ side }) =>
    side === "A"
      ? "var(--mode-bg-primary-weak)"
      : "var(--mode-bg-secondary-weak)"};
  }
`;
export const Container = styled.div<{
  numberOfLines: number;
}>`
  position: relative;
  width: 100%;
  height: ${({ numberOfLines }) => cellHeight * numberOfLines}px;
`;

export const Node = styled.div<{
  level: number;
  highlighted: boolean;
  truncated?: boolean;
}>`
  box-sizing: border-box;
  position: absolute;

  height: ${cellHeight}px;
  top: ${({ level }) => cellHeight * level}px;

  opacity: ${({ truncated }) => (truncated ? 0.4 : 1)};

  background-color: var(--theme-neutral-100);
  border: 1px solid
    ${({ highlighted }) =>
      highlighted
        ? "var(--mode-border-primary-strong)"
        : "var(--section-snow-background-color, var(--snow))"} !important;
  border-left-width: ${({ truncated }) => (truncated ? 0 : 1)}px !important;
  border-right-width: ${({ truncated }) => (truncated ? 0 : 1)}px !important;
  box-shadow: none !important;

  cursor: pointer;

  &:hover > div {
    border-color: var(--theme-neutral-400);
  }

  > div {
    position: absolute;
  }
`;

export const NodeBackground = styled.div`
  background-color: var(--profile-type-color);
  left: 1px;
  right: 1px;
  top: 1px;
  bottom: 1px;
`;

export const ComparisonNodeBackground = styled.div<{
  delta: number | undefined;
  side: ComparisonSide;
}>`
  background-color: ${({ delta, side }) =>
    delta === undefined
      ? side === "A"
        ? "var(--mode-bg-primary-weak)"
        : "var(--mode-bg-secondary-weak)"
      : side === "A"
        ? "var(--theme-neutral-100)"
        : delta === 0
          ? "transparent"
          : delta > 0
            ? "var(--color-red-500)"
            : "var(--color-java-500)"};
  left: 1px;
  right: 1px;
  top: 1px;
  bottom: 1px;
`;

export const NodeLabel = styled.div`
  left: 4px;
  right: 4px;
  top: 2px;
  bottom: 2px;
  overflow: hidden;
  display: block;
  font-size: 12px;
  min-width: 1px;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
